module.exports = __webpack_public_path__ + "static/1-010-54dd1145b5b99dd80d625debb1d3b4b1.png";